import { useState, useRef, useEffect } from "react";
const ColumnSelection = ({ visibleColumns,setVisibleColumns }) => {
  const [showColumnPanel, setShowColumnPanel] = useState(false);
  const panelRef = useRef(null);
  const buttonRef = useRef(null); 

  const handleColumnSelectionButton = () => {
    setShowColumnPanel((prev) => !prev);
  };

  const toggleColumnVisibility = (column) => {
    setVisibleColumns((prev) => ({
      ...prev,
      [column]: !prev[column],
    }));
  };

  useEffect(() => {

    const handleClickOutside = (event) => {
      // Check if the click is outside the panel AND not on the button
      if (
        panelRef.current && 
        !panelRef.current.contains(event.target) && 
        buttonRef.current && 
        !buttonRef.current.contains(event.target)
      ) {
        setShowColumnPanel(false);
      }
    };

    if (showColumnPanel) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showColumnPanel]);

  return (
    <div className="position-relative d-flex align-items-center">
      <span
        onClick={handleColumnSelectionButton}
        ref={buttonRef}
        className="btn btn-white d-flex align-items-center px-3"
        style={{ height: "100%", minHeight: "38px" }}
      >
        <b className="fa fa-plus opacity-5"></b>
      </span>

      {showColumnPanel && (
        <div
          ref={panelRef}
          className="column-panel"
          style={{
            position: "absolute",
            top: "45px",
            right: "0px",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            width: "150px",
            zIndex: 1000,
          }}
        >
          {Object.keys(visibleColumns).map((column) => (
            <div key={column} className="p-2">
              <input
                type="checkbox"
                checked={visibleColumns[column]}
                onChange={() => toggleColumnVisibility(column)}
              />
              <label className="ms-2">{column.charAt(0).toUpperCase() + column.slice(1)}</label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ColumnSelection;
